/**
 * Installation Fee — Global Controller
 * Uses event delegation so it survives cart drawer DOM re-renders.
 * Integrates with Nitro theme's EventBus for cart refresh.
 */
(function () {
  var VARIANT_ID = 53395126124817;
  var STORAGE_KEY = 'tdi_installation_fee';
  var SELECTOR = '.js-installation-fee-checkbox';
  var busy = false;

  /* ---- Cart helpers ---- */

  function getCartKey() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === VARIANT_ID) return cart.items[i].key;
        }
        return null;
      });
  }

  function addToCart() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
    }).then(function (r) { return r.json(); });
  }

  function removeFromCart(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  /* ---- Theme integration ---- */

  function refreshCartDrawer() {
    /* Prefer the theme's EventBus for a proper section re-render */
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.emit('cart:refresh');
    }
    /* Legacy fallback */
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* ---- Checkbox sync ---- */

  function syncAllCheckboxes(checked) {
    document.querySelectorAll(SELECTOR).forEach(function (cb) {
      cb.checked = checked;
    });
    sessionStorage.setItem(STORAGE_KEY, checked ? 'true' : 'false');
  }

  function syncFromCart() {
    return getCartKey().then(function (key) {
      var inCart = !!key;
      syncAllCheckboxes(inCart);
      return inCart;
    });
  }

  /* ---- Event delegation: checkbox change ---- */

  document.addEventListener('change', function (e) {
    var cb = e.target.closest(SELECTOR);
    if (!cb || busy) return;

    var checked = cb.checked;
    busy = true;
    syncAllCheckboxes(checked);

    if (checked) {
      getCartKey().then(function (key) {
        if (key) { busy = false; return; }
        return addToCart().then(function () {
          refreshCartDrawer();
          busy = false;
        });
      }).catch(function () { busy = false; });
    } else {
      getCartKey().then(function (key) {
        if (!key) { busy = false; return; }
        return removeFromCart(key).then(function () {
          refreshCartDrawer();
          busy = false;
        });
      }).catch(function () { busy = false; });
    }
  });

  /* ---- Listen for theme cart updates (item removed via X, quantity change, etc.) ---- */

  function onThemeCartUpdate() {
    /* Wait a tick so the section re-render has fetched new HTML */
    setTimeout(syncFromCart, 300);
  }

  /* Hook into the theme EventBus once it's ready */
  function attachEventBus() {
    if (window.themeCore && window.themeCore.EventBus) {
      window.themeCore.EventBus.listen('cart:refresh', onThemeCartUpdate);
      window.themeCore.EventBus.listen('cart:updated', onThemeCartUpdate);
    }
  }

  /* Also observe DOM mutations on the cart drawer to re-sync after section re-render */
  function observeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var observer = new MutationObserver(function () {
      /* After DOM replacement, sync checkbox state from sessionStorage immediately */
      var stored = sessionStorage.getItem(STORAGE_KEY) === 'true';
      document.querySelectorAll(SELECTOR).forEach(function (cb) {
        cb.checked = stored;
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  /* ---- Init ---- */

  function init() {
    /* Sync from actual cart state on page load */
    syncFromCart();
    attachEventBus();
    observeDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* If themeCore loads after us, re-attach */
  document.addEventListener('theme:all:loaded', attachEventBus);
})();
